
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import HeaderOne from "../components/header/HeaderOne";
import { Link } from 'react-router-dom';
import FooterOne from "../components/footer/FooterOne";
import Breadcrumb from "./Breadcrumb";
import { API_ENDPOINTS } from '../config/api';

function ContactUs() {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Contact Us' }
    ];

    const schemaData = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "ContactPage",
                "@id": "https://www.aviteusbusiness.co.uk/contactus#page",
                "url": "https://www.aviteusbusiness.co.uk/contactus",
                "name": "Contact Aviteus | UK Accountants for SMEs and Startups",
                "description": "Speak to Aviteus about bookkeeping, payroll, VAT and tax. UK-wide service with fixed fees and clear advice.",
                "inLanguage": "en-GB",
                "isPartOf": {"@id": "https://www.aviteusbusiness.co.uk/#website"},
                "about": {"@id": "https://www.aviteusbusiness.co.uk/#business"},
                "primaryImageOfPage": "https://www.aviteusbusiness.co.uk/assets/contact.jpg"
            },
            {
                "@type": "Place",
                "@id": "https://www.aviteusbusiness.co.uk/contactus#place",
                "name": "Aviteus Business Solutions Office",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "Alpha House, 296 Kenton Rd",
                    "addressLocality": "Harrow",
                    "postalCode": "HA3 8DD",
                    "addressCountry": "GB"
                },
                "telephone": "+44 20 4628 8209"
            },
            {
                "@type": "BreadcrumbList",
                "@id": "https://www.aviteusbusiness.co.uk/contactus#breadcrumbs",
                "itemListElement": [
                    {"@type":"ListItem","position":1,"name":"Home","item":"https://www.aviteusbusiness.co.uk/"},
                    {"@type":"ListItem","position":2,"name":"Contact","item":"https://www.aviteusbusiness.co.uk/contactus"}
                ]
            }
        ]
    };

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatusMessage('');

        try {
            const response = await fetch(API_ENDPOINTS.SEND_EMAIL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (response.ok && data.success) {
                setStatusMessage('✓ ' + data.message);
                setFormData({ name: '', email: '', subject: '', message: '' });
            } else {
                setStatusMessage('✗ ' + (data.message || 'Failed to send message'));
            }
        } catch (error) {
            console.error('Contact form error:', error);
            setStatusMessage('✗ Failed to send message. Please try again later or email us directly.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className=''>
            <Helmet>
                <title>Contact Aviteus | UK Accountants for SMEs and Startups</title>
                <meta name="description" content="Speak to Aviteus about bookkeeping, payroll, VAT and tax. UK-wide service. Fixed fees and clear advice. Book a free discovery call." />
                <link rel="canonical" href="https://www.aviteusbusiness.co.uk/contactus" />
                <script type="application/ld+json">
                    {JSON.stringify(schemaData)}
                </script>
            </Helmet>

            <HeaderOne />

            <Breadcrumb title="Contact Us" breadcrumbs={breadcrumbs} />

            {/* contact single area start */}
            <div className="rts-contact-area rts-section-gap">
                <div className="container">
                    <div className="row g-5">
                        {/* single contact area */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="single-contact-one-inner">
                                <div className="thumbnail">
                                    <img src="assets/images/contact/01.png" alt="" />
                                </div>
                                <div className="content">
                                    <div className="icone">
                                        <img src="assets/images/contact/shape/01.svg" alt="" />
                                    </div>
                                    <div className="info">
                                        <span>Phone</span>
                                        <Link to={'tel:02046288209'}>
                                            <h5>020 4628 8209</h5>
                                        </Link>
                                        <p style={{fontSize: '14px', marginTop: '5px'}}>Monday to Friday, 9 am to 5 pm. Saturday by appointment.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* single contact area end */}
                        {/* single contact area */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="single-contact-one-inner">
                                <div className="thumbnail">
                                    <img src="assets/images/contact/02.png" alt="" />
                                </div>
                                <div className="content">
                                    <div className="icone">
                                        <img src="assets/images/contact/shape/02.svg" alt="" />
                                    </div>
                                    <div className="info">
                                        <span>Email Us</span>
                                        <Link to={'mailto:info@aviteusbusiness.co.uk'}>
                                            <h5>info@aviteusbusiness.co.uk</h5>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* single contact area end */}
                        {/* single contact area */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="single-contact-one-inner">
                                <div className="thumbnail">
                                    <img src="assets/images/contact/03.png" alt="" />
                                </div>
                                <div className="content">
                                    <div className="icone">
                                        <img src="assets/images/contact/shape/03.svg" alt="" />
                                    </div>
                                    <div className="info">
                                        <span>Address</span>
                                        <Link to={'#'}>
                                            <h5>Alpha House, 296 Kenton Rd, Harrow, HA3 8DD</h5>
                                        </Link>
                                        <p style={{fontSize: '14px', marginTop: '5px'}}>UK-wide coverage using secure cloud systems</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* single contact area end */}
                    </div>
                </div>
            </div>
            {/* conact single area end */}
            {/* bizup map area start */}
            <div className="rts-contact-map-area">
                <div className="contaciner-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="contact-map-area-fluid">
                                <iframe
                                    className="contact-map"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2476.1234567890123!2d-0.3077795079246079!3d51.587419243488576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTHCsDM1JzE0LjciTiAwwrAxOCcyOC4wIlc!5e0!3m2!1sen!2suk!4v1635000000000!5m2!1sen!2suk"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* bizup map area end */}
            {/* conact us form fluid start */}
            <div className="rts-contact-form-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="rts-contact-fluid rts-section-gap">
                                <div className="rts-title-area contact-fluid text-center mb--50">
                                    <p className="pre-title">Get In Touch</p>
                                    <h2 className="title">Let's Talk About Your Business Growth</h2>
                                    <p className="disc">
                                        You deserve fast, clear answers. Use the details below to reach our team. We respond within one business day and can meet online or in person.
                                    </p>
                                </div>
                                <div className="form-wrapper">
                                    {statusMessage && (
                                        <div id="form-messages" style={{
                                            padding: '15px',
                                            marginBottom: '20px',
                                            borderRadius: '5px',
                                            backgroundColor: statusMessage.startsWith('✓') ? '#d4edda' : '#f8d7da',
                                            color: statusMessage.startsWith('✓') ? '#155724' : '#721c24',
                                            border: `1px solid ${statusMessage.startsWith('✓') ? '#c3e6cb' : '#f5c6cb'}`
                                        }}>
                                            {statusMessage}
                                        </div>
                                    )}
                                    <form id="contact-form" onSubmit={handleSubmit}>
                                        <div className="name-email">
                                            <input
                                                type="text"
                                                name="name"
                                                placeholder="Your Name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Email Address"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <input
                                            type="text"
                                            name="subject"
                                            placeholder="Your Subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                        />
                                        <textarea
                                            placeholder="Type Your Message"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        />
                                        <button type="submit" className="rts-btn btn-primary" disabled={loading}>
                                            {loading ? 'Sending...' : 'Send Message'}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* conact us form fluid end */}

            <FooterOne />

        </div>
    )
}

export default ContactUs